/**
 * Shared channel display name.
 *
 * Same precedence the composer / Channels page use (`metadata.displayName`,
 * then the platform username), plus the release API's `name`/`username`.
 * Never falls back to a raw platform user id or the uppercase platform enum:
 * the last resort is the human platform name ("Google Business Profile").
 */

import { getPlatformDisplayName } from '@/constants/platformLimits';

export interface ChannelLabelSource {
  platform: string;
  /** Release API channel name */
  name?: string | null;
  /** Release API handle */
  username?: string | null;
  platformUsername?: string | null;
  metadata?: Record<string, unknown> | null;
}

const asText = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

export function getChannelDisplayName(channel: ChannelLabelSource): string {
  return (
    asText(channel.metadata?.displayName) ||
    asText(channel.name) ||
    asText(channel.platformUsername) ||
    asText(channel.username) ||
    getPlatformDisplayName(channel.platform.toLowerCase())
  );
}
